import { LocationACL } from '@raydiant/api-client-js';
import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';

interface RemoveAccessDialogProps {
  isOpen: boolean;
  acl: LocationACL;
  type?: string;
  onClose: () => void;
  onSubmit: () => void;
}

const RemoveAccessDialog = ({
  isOpen,
  acl,
  type = 'content',
  onClose,
  onSubmit,
}: RemoveAccessDialogProps) => {
  const name = acl.grantDomainId
    ? 'Everyone At Domain'
    : acl?.grantProfile?.name;

  return (
    <Modal isOpen={isOpen}>
      <Dialog showCloseButton={true} onClose={onClose}>
        <DialogHeader>
          <DialogHeading>
            <span className="text-black">Confirm Remove User</span>
          </DialogHeading>
        </DialogHeader>

        <div className="px-4 py-6">
          <Text className="text-black" variant="body">
            Are you sure you want to remove "{name}" from this {type}?
          </Text>
        </div>

        <div className="flex flex-col-reverse justify-between pt-2 pb-4 gap-3 px-0 md:gap-6 md:flex-row md:px-4">
          <Button
            onPress={() => onClose()}
            variant="secondary"
            size="large"
            className="grow"
          >
            Cancel
          </Button>
          <Button
            onPress={() => onSubmit()}
            variant="caution"
            size="large"
            className="grow"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
};

export default RemoveAccessDialog;
